<template>
  <div v-if="lastLogin" class="last-login-info">
    <span>{{ $t("common.last_login") }}:</span>
    <span>{{ lastLogin }}</span>
  </div></template
>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({ currentUser: "user/getUser" }),
    lastLogin() {
      if (!this.currentUser || !this.currentUser.last_login) return "";
      const d = new Date(this.currentUser.last_login);
      const dateValue = d.toLocaleDateString();
      const timeValue = d.toLocaleTimeString();
      return `${dateValue}, ${timeValue}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.last-login-info {
  position: fixed;
  max-width: 240px;
  display: flex;
  gap: 4px;
  bottom: 16px;
  left: 0;
  font-size: 14px;
  padding: 0 8px;
}
</style>
